import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";
import {Observable} from "rxjs/Rx";

/*
  Generated class for the AccountProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AccountProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello AccountProvider Provider');
  }

  price_list;
  getPriceList(){
   return this.price_list?Observable.of(this.price_list):this.http.hPost('/account/get_price_list').map(res => {this.price_list = res['content']['price_info'];return this.price_list});
  }

  getPaySign(price_id){
    return this.http.hPost('/account/pay_sign',{price_id:price_id});
  }

  verifyPay(pay_id){
    return this.http.hPost('/account/verify_pay',{pay_id:pay_id});
  }

  switchNotice(is_switch){
    return this.http.hPost('/account/notice_switch',{switch:is_switch});
  }

  getVipMenu(vip_level){
    return this.http.hPost('/account/vip_menu',{vip_level:vip_level});
  }
  //
  // preChangeVip(vip_level){
  //   return this.http.hPost('/account/pre_vip_switch',{switch:vip_level})
  // }

  changeVip(vip_level,confirmed = 0){
    return this.http.hPost('/account/vip_switch',{switch:vip_level,confirmed:confirmed})
  }

}



// WEBPACK FOOTER //
// ./src/providers/account/account.ts